import React from 'react';
import { getLabel } from '../../../data/labels';
import { xs_isMobile } from '../../..';
import { getConfiguration } from '../../utils/configuration';
import { concatUrlPathnames } from '../../sport-utils';

export default function LoadBetButton(props) {
    const conf = getConfiguration();

    const routes = window.appConfig.ROUTES;
    let url = null;

    if (conf.seo != null) {
        if (xs_isMobile) {
            url = `https://${conf.url}${concatUrlPathnames(routes.prematch.prematch,'loadbet')}?ticketId=${props.ticketId}`;
            //url = `https://${conf.url}${routes.prematch.prematch}/loadbet?ticketId=${props.ticketId}`;
        } else {
            url = `https://${conf.url}${concatUrlPathnames(routes.prematch['top-match'],'loadbet')}?ticketId=${props.ticketId}`
            //url = `https://${conf.url}${routes.prematch['top-match']}/loadbet?ticketId=${props.ticketId}`;
        }
    } else {
        url = conf.xspu?.ldb?.replace('{{TICKET_ID}}', props.ticketId) ?? null;
    }

    if (url == null || conf?.rets) {
        return null;
    }

    return (
        <a href={url} target="_blank" rel="noreferrer" className="checkbet-button | mb_7_1_3">{getLabel('mybets.add_to_cart')}</a>
    );
}
